import api from "../api/axios";
import { companyID } from "../auth";

export const getEmployerDocumentTypes = async () => {
  try {
    const company_id = companyID();
    const response = await api.get(`api/documents/document-type/${company_id}`);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const uploadDocumentsData = async (formData) => {
  try {
    const response = await api.post(`api/documents/upload-documents`, formData);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};
